<div class="comments-panel" *ngIf="reviewerMode$ | async">
  <div class="panel-header">
    <mat-icon class="panel-icon">chat</mat-icon>
    <span class="panel-title">Comments</span>
    <span class="panel-count" *ngIf="comments$ | async as list">{{ list.length }}</span>
  </div>

  <div class="panel-body" *ngIf="comments$ | async as comments; else noComments">
    <ng-container *ngIf="comments.length; else noComments">
      <mat-card class="comment-card" *ngFor="let c of comments; trackBy: trackById">
        <div class="comment-meta">
          <span class="comment-author">{{ c.authorName }}</span>
          <span class="comment-date">{{ c.createdAt | date: 'short' }}</span>
        </div>
        <div class="comment-node">on {{ c.nodeName || 'Node ' + c.nodeId }}</div>
        <div class="comment-content">{{ c.content }}</div>
      </mat-card>
    </ng-container>
  </div>

  <ng-template #noComments>
    <div class="empty">No comments yet.</div>
  </ng-template>
</div>
